// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Belt_Array = require("bs-platform/lib/js/belt_Array.js");

function init_matrix(dimx, dimy, fn) {
  return Belt_Array.makeBy(dimy, (function (y) {
                return Belt_Array.makeBy(dimx, (function (x) {
                              return Curry._1(fn, /* tuple */[
                                          x,
                                          y
                                        ]);
                            }));
              }));
}

function make_matrix(dimx, dimy, value) {
  return init_matrix(dimx, dimy, (function (param) {
                return value;
              }));
}

function pad(v, padding, arr) {
  return Belt_Array.make(padding, v).concat(arr).concat(Belt_Array.make(padding, v));
}

function pad_matrix(v, padding, matrix) {
  return pad(Belt_Array.make(matrix[0].length + (padding << 1) | 0, v), padding, matrix.map((function (param) {
                    return pad(v, padding, param);
                  })));
}

function transpose(matrix) {
  var dimy = matrix.length;
  var dimx = matrix[0].length;
  return Belt_Array.makeBy(dimx, (function (x) {
                return Belt_Array.makeBy(dimy, (function (y) {
                              return matrix[y][x];
                            }));
              }));
}

function trimi(predicate, arr) {
  var start = arr.findIndex((function (item, i) {
          return !Curry._2(predicate, item, i);
        }));
  var e = Belt_Array.reverse(arr).findIndex((function (item, i) {
          return !Curry._2(predicate, item, i);
        }));
  var end_ = e === 0 ? arr.length : -e | 0;
  return arr.slice(start, end_);
}

function trim(predicate) {
  return (function (param) {
      return trimi((function (item, param) {
                    return Curry._1(predicate, item);
                  }), param);
    });
}

function trim_matrix(predicate, arr) {
  return transpose((function (param) {
                  return trimi((function (item, param) {
                                var param$1 = item;
                                return param$1.every(Curry.__1(predicate));
                              }), param);
                })(transpose((function (param) {
                          return trimi((function (item, param) {
                                        var param$1 = item;
                                        return param$1.every(Curry.__1(predicate));
                                      }), param);
                        })(arr))));
}

exports.init_matrix = init_matrix;
exports.make_matrix = make_matrix;
exports.pad = pad;
exports.pad_matrix = pad_matrix;
exports.transpose = transpose;
exports.trimi = trimi;
exports.trim = trim;
exports.trim_matrix = trim_matrix;
/* No side effect */
